import { Link, Paper } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { ControllerRouteInformation } from '@/features/controller/constants'

interface ConfigVersionNavigationLinksProps {
  configVersionId: string
  controllerId: string
  previousVersionId: string
  onVersionChange?: (versionId: string) => void
}

export function ConfigVersionNavigationLinks({
  configVersionId,
  controllerId,
  previousVersionId,
  onVersionChange,
}: Readonly<ConfigVersionNavigationLinksProps>) {
  const { t } = useTranslation()

  return (
    <Paper sx={{ p: 3, mt: 2 }}>
      {onVersionChange ? (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <Link
          component="button"
          sx={{ textDecoration: 'underline', background: 'none', border: 'none' }}
          onClick={() => onVersionChange(previousVersionId!)}
        >
          {t('controllers.configuration.version.previous_version')}
        </Link>
      ) : (
        <Link href={ControllerRouteInformation.CONTROLLER_CONFIG_VIEW.navigationPath(controllerId, previousVersionId)}>
          {t('controllers.configuration.version.previous_version')}
        </Link>
      )}

      {` | `}
      <Link
        href={ControllerRouteInformation.CONTROLLER_CONFIG_DIFF.navigationPath(
          controllerId,
          configVersionId,
          previousVersionId,
        )}
      >
        {t('controllers.configuration.version.compare_with_previous')}
      </Link>
    </Paper>
  )
}
